import React, { useCallback, useEffect, useState } from 'react';
import { Button } from 'js/components/main/LeaderboardButton/Button';
import { LocalPopup } from 'js/components/common/Popup';
import style from './index.scss';
import { usePortletTranslations } from '../../../../system/Portlet';
import classNames from '../../Details/classNames';

export const OkButton = ({ onClick, buttonText, isInErrorModal }) => (
    <Button
        view='primary'
        variant='rounded'
        color='lbSuccess'
        size='large'
        onClick={onClick}
        classname={classNames(style.button, style.stayButton, { [style.inErrorButtonStyle]: isInErrorModal })}>
        { buttonText }
    </Button>
);

export const popupClassNames = { inner: style.popupInner };

export default () => {
    const t = usePortletTranslations();
    const [isShowModal, setIsShowModal] = useState(false);
    useEffect(() => {
        setTimeout(() => { setIsShowModal(true); }, 500);
    }, []);
    const onCloseButtonClick = useCallback(() => {
        window.parent?.postMessage('{close-cp-iframe}', '*');
    }, []);
    return <> { isShowModal ? <LocalPopup onClose={onCloseButtonClick}
                className={style.popup}
                classNames={popupClassNames}
                iconType='lbLeaveRaceIconClose'>
        <div className={style.content}>
            <p className={style.title}>{t('promotionNotAvailable')}</p>
        </div>
        <div className={style.actions}>
            <OkButton onClick={onCloseButtonClick} buttonText={t('ok')} isInErrorModal={true}/>
        </div>
    </LocalPopup> : <></>
        };
    </>;
};
